import React from 'react';
import './Valid.sass';

export default function Valid() {
	return (
		<svg
			width="20px"
			height="20px"
			viewBox="0 0 20 20"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g fill="#279F00">
					<g>
						<path d="M10,1 C5.038,1 1,5.038 1,10 C1,14.962 5.038,19 10,19 C14.962,19 19,14.962 19,10 C19,5.038 14.962,1 10,1 Z M10,20 C4.486,20 0,15.514 0,10 C0,4.486 4.486,0 10,0 C15.514,0 20,4.486 20,10 C20,15.514 15.514,20 10,20 L10,20 Z" />
						<polyline points="7.727 14.956 3.397 10.637 4.103 9.929 7.727 13.544 15.897 5.396 16.603 6.104 7.727 14.956" />
					</g>
				</g>
			</g>
		</svg>
	);
}
